<template>
    <grid-loader :loading="isLoading" :color="spinnerColor" class="middle_abs"></grid-loader>  
    <div  class="container mt-1">
    <div class="d-flex justify-content-between align-items-center">
        <div class="topTitle">素材管理</div>
      
            <input type="file" ref="folderInput" webkitdirectory multiple style="display: none" @change="uploadFolder(0)"  accept="image/*">

            <div @click="selectFolder" class="btnAdd">上传文件夹</div>

            <input type="file" ref="filesInput" multiple style="display: none" @change="uploadFolder(1)"  accept="image/*">
            <div @click="selectFiles" class="ml-2 btnAdd">上传文件</div>
       </div>

       <div v-if="folderUploadProgress > 0 && folderUploadProgress<100">
                    正在上传文件：{{folderUploadProgress}}%
                    <progress :value="folderUploadProgress" max="100"></progress>

       
    </div>
    <div class="error-message">
           
            <div v-for="(error) in errors" :key="error">
                {{ error }}
            </div>
        </div>


    <div v-if="files.length==0" class="title mt-1">暂无</div>    
    
    <div v-else>

       
        <table  class="mt-1">
            <tr class="table_title">
            <th></th>
            <th>文件</th>
           
           
            <th>上传日期</th>
            <th>素材数量</th>
            <th>操作</th>
            </tr>

            <tr v-for="(file,index) in files" :key="index">
                <td>{{ index+1 }}</td>
                <td>
                   <a :href="file.img_url" target="blank"><img :src="file.img_url" class="img"></a> 
                </td>
               
               
                <td>
                    {{ localDatetime(file.createdDate) }}
                </td>
                <td>{{ file.count }}</td>
                <td>
                    <div  class="backBtn mr-1" @click="deleteSucai(file.objectId,index)">删除</div>
                    
                </td>

            </tr>
        </table>
    </div>

    <div class="mt-1 mb-1 d-flex justify-content" v-if="totalPage>1">
          <div v-for="(n,index) in totalPage" :key="index">
            <div :class="n==page+1?'pageBox mr-1 selectedPageBox':'pageBox mr-1 normalPage'" @click="changePage(n-1)">
              {{ n }}
            </div>
            
          </div>

        </div>

    <PopupWindow v-model:isShow="showPopup">
        <SucaiGroup @add_suc="add_group" :group="selectedGroup"></SucaiGroup>
    </PopupWindow>  
    </div>
  
  
  </template>
  
  <script>
  
  import GridLoader from 'vue-spinner/src/GridLoader.vue'
  import axios from 'axios';
  import PopupWindow from '@/components/PopupWindow.vue';
  import SucaiGroup from '@/components/SucaiGroup.vue';
  import moment from 'moment'
  
  
  export default {
    data(){
      
      return {
        files:[],
        groupId:null,
        isLoading:false,
        
        showPopup: false,
        selectedGroup:null,
        folderUploadProgress:0,
       
        spinnerColor:"#262626",
        errors:[],
        totalPage:0,
        totalCount:0,
        page:0,
        count:10
      }
      
    },
      computed: {
        localDatetime() {
            return (datetimeString) => {
            let beijingTime = moment(datetimeString).utcOffset('+08:00').format('YYYY-MM-DD HH:mm:ss');
            return beijingTime
            
            }
        }
        },
    components: {
      GridLoader,
      PopupWindow,  
      SucaiGroup
    },
    
     setup(){
      
       var token=localStorage.getItem('sessionToken')
       axios.defaults.headers.common['X-Parse-Session-Token'] = token
  
    },
  
 
  
    mounted(){
      var token=localStorage.getItem('sessionToken');
      this.role=localStorage.getItem('role');
  
       if(token==undefined || token==null ||token=='')
       {
          this.$router.push('index')
          return
       }

       this.groupId = this.$route.params.id;

       this.getPages();
    },
    methods:{
        changePage(page){
            this.page=page;
            this.getFiles()

        },
        deleteFile(file){
            console.log(file)

        },
        selectFolder(){
            this.$refs.folderInput.click();
        },

        selectFiles(){
            this.$refs.filesInput.click()
        },
        
        async deleteSucai(file_id,index){
      try{
        this.isloading=true;
        const response = await axios.get(this.domain+'xhs/delete_sucai_file?file_id='+file_id);
        var data=response.data
        if(data.status=='Suc')
        {
            this.files.splice(index,1)
        }
        else
        {
            console.error(data)
        }
      }
      catch(error)
      {
          console.error(data)
      }
      finally{
        this.isLoading=false;
      }
    },

        async getPages(){
        try{
            this.isLoading=true;
            const response = await axios.get(this.domain+'xhs/get_sucai_files_count?group_id='+this.groupId);
            var data=response.data
            if(data.status=='Suc')
            {
                var results=data.count
                this.totalCount=results;
                this.totalPage=Math.ceil(results/this.count);
                this.page=0

                this.getFiles()
            }
            else
            {
                console.error(data)
            }
        }
        catch(error)
        {
            console.error(data)
        }
        finally{
            this.isLoading=false;
        }
        },

        async getFiles(){
        try{
            this.isLoading=true;
            const response = await axios.get(this.domain+'xhs/get_sucai_files?group_id='+this.groupId+'&page='+this.page+'&count='+this.count);
            var data=response.data
            if(data.status=='Suc')
            {
                var results=data.files
                this.files=results
            }
            else
            {
                console.error(data)
            }
        }
        catch(error)
        {
            console.error(data)
        }
        finally{
            this.isLoading=false;
        }
        },

        uploadFolder(type){
            this.isLoading=true
            this.errors=[]
            try{
                var files =null
                if (type==0)
                {
                    files =  this.$refs.folderInput.files;
                }
                else
                {
                    files =  this.$refs.filesInput.files;
                }
                
                console.log(files)
                const data = new FormData();
                data.append("id", this.groupId);
                for (let i = 0; i < files.length; i++) {
                   
                const file = files[i];
                if (!file.type.startsWith('image/')) {
                    console.log(file.name)
                        this.errors.push(file.name+'不是图片类型，无法上传')
                        console.log(this.errors)
                        continue;  //如果文件不是图片，就跳过这个文件
                    }

                    
                data.append('file', file);
            }

            this.$refs.folderInput.value = ''
            this.$refs.filesInput.value = ''

            const config = {
                onUploadProgress: progressEvent => {
                const percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                );
                this.folderUploadProgress = percentCompleted;
                },
            };

        

        this.progressing=true;
            axios
            .post(this.domain+"xhs/upload_sucai_files", data, config)
            .then(response => {
                console.log(response)
                let dataResponse=response.data
                if (dataResponse['status']=='Suc')
                {
                    var newFiles=dataResponse['photoes']

                    this.totalCount+=newFiles.length;
                    this.totalPage=Math.ceil(this.totalCount/this.count);
                    this.page=0

                    this.getFiles()

                    
                }
            // 处理响应
            })
            .catch(error => {
                console.log(error)
                this.errors=error;
            // 处理错误
            });
            }
            catch(error){
                console.error(error)
                this.errors=error;
            }
            finally{
                console.log('finished')
                this.isLoading=false
            }
       
    },


    }
  };
  </script>
  <style scoped>

  .img{
    width:1rem;
    height:1rem;
  }
  </style>
  
  
  